import { CustomerOrder } from "./system/Domain";
import { MouseEvent } from "react";

export const capitalize = function (str: string) {
	return str.charAt(0).toUpperCase() + str.substr(1);
};

export function getEnumName<T extends { [index: string]: string }>(enumType: T, enumValue: string): keyof T | null {
	let keys = Object.keys(enumType).filter(x => x === enumValue);
	return keys.length > 0 ? enumType[keys[0]] : null;
};

export const copyClick = (e: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>, content: string) => {
	e.preventDefault();

	const textField = document.createElement('textarea');
	textField.innerText = content;
	document.body.appendChild(textField);
	if (window.navigator.platform === 'iPhone') {
		textField.setSelectionRange(0, 99999)
	} else {
		textField.select()
	}
	document.execCommand('copy')
	textField.remove()
};

export const generateCustomerOrderLink = (customerOrder: CustomerOrder): string => {
	return `${window.location.protocol}//${window.location.host}/orders/customers/form/${customerOrder?.id}?access_token=${customerOrder?.token}`;
};

export const containsAny = (text: string, values: string[]) => text && values.some(sd => text.toLowerCase().includes(sd.toLowerCase()));
